import './components/index.mjs';
export { UiLoadingPropsOption } from './components/loading/src/loading.mjs';
export { default as UiLoading } from './components/loading/src/loading.vue.mjs';

const UiFormEmitterKey = Symbol("UiFormEmitterKey");
const UiFormDataKey = Symbol("UiFormDataKey");
const UiFormRulesKey = Symbol("UiFormRulesKey");

export { UiFormDataKey, UiFormEmitterKey, UiFormRulesKey };
//# sourceMappingURL=index.mjs.map
